import { render, staticRenderFns } from "./UCRadio.vue?vue&type=template&id=0cb5d568&scoped=true&"
import script from "./UCRadio.vue?vue&type=script&lang=ts&"
export * from "./UCRadio.vue?vue&type=script&lang=ts&"
import style0 from "./UCRadio.vue?vue&type=style&index=0&id=0cb5d568&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5d568",
  null
  
)

export default component.exports